/* eslint-disable no-plusplus */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/sort-comp */
import React from 'react';
import gsap from 'gsap';

// modules
import { CustomEaseJorisOut } from '@shcc/modules/CustomEaseModule';
import bindAll from '@shcc/utils/helpers/bindAll';
import styles from './ButtonSecondary.module.scss';

export default class ButtonSecondaryBackground extends React.Component {
  constructor() {
    super();

    bindAll(this, ['tickHandler', 'updateRequestedHandler']);

    this.element = React.createRef();

    this.pool = [];
  }

  componentDidMount() {
    this.setupCanvas();
    this.setupEventListeners();
  }

  componentWillUnmount() {
    this.removeEventListeners();
  }

  render() {
    return <canvas ref={this.element} className={styles.background} />;
  }

  add(options = {}) {
    // Add item to pool
    const item = this.getPoolItem(options.color);
    this.pool.push(item);

    gsap.to(this.getLastPoolItem(), {
      duration: 0.6,
      x: 0.0,
      width: 1.0,
      ease: CustomEaseJorisOut,
      delay: options.delay ? options.delay : 0,
      onUpdate: this.updateRequestedHandler,
    });
  }

  remove(options = {}) {
    gsap.to(this.getLastPoolItem(), {
      duration: 0.6,
      width: 0.0,
      ease: CustomEaseJorisOut,
      delay: options.delay ? options.delay : 0,
      onUpdate: this.updateRequestedHandler,
      onComplete: () => {
        this.pool.shift();
      },
    });
  }

  setSize(width, height, scale) {
    this.width = width;
    this.height = height;

    this.canvas.width = width * scale;
    this.canvas.height = height * scale;

    this.ctx.scale(scale, scale);
  }

  setupCanvas() {
    this.canvas = this.element.current;
    this.ctx = this.canvas.getContext('2d');
  }

  setupEventListeners() {
    gsap.ticker.add(this.tickHandler);
  }

  removeEventListeners() {
    gsap.ticker.add(this.tickHandler);
  }

  getPoolItem(color) {
    return {
      x: 1.0,
      y: 0.0,
      width: 0.0,
      height: 1.0,
      color: color || '#ffffff',
    };
  }

  getLastPoolItem() {
    return this.pool[this.pool.length - 1];
  }

  draw() {
    if (this.pool.length < 1) return;
    this.ctx.clearRect(0, 0, this.width, this.height);

    const limit = this.pool.length;

    let index;
    let item;

    for (index = 0; index < limit; index++) {
      item = this.pool[index];

      this.ctx.beginPath();
      this.ctx.fillStyle = item.color;
      this.ctx.rect(
        item.x * this.width,
        item.y * this.height,
        item.width * this.width,
        item.height * this.height
      );
      this.ctx.fill();
      this.ctx.closePath();
    }
  }

  /**
   *
   * Handlers
   */
  updateRequestedHandler() {
    this.isUpdateRequested = true;
  }

  tickHandler() {
    if (this.isUpdateRequested) {
      this.isUpdateRequested = false;
      this.draw();
    }
  }
}
